import { put } from 'redux-saga/effects';
import {
  UPDATE_PERSISTED_COMMON_STATE,
  UPDATE_PERSISTED_COMMON_STATE_FOR_PRESET,
} from '@store/common/types';
import { UPDATE_PERSISTED_NOC_STATE } from '@store/noc/base/types';
import { UPDATE_PERSISTED_OVERVIEW_STATE } from '@store/overviewDashboard/base/types';
import { UPDATE_PERSISTED_ML_STATE } from '@store/metricLens/base/types';
import { UPDATE_PERSISTED_VM_STATE } from '@store/viewerModule/types';
import { urlTransform } from './urlTransform';
import { validPresetKeys } from '@src/components/common/Dashboard/UseCases/utils';

const { baseUrl } = window.conviva;

export const trendsRouteKey = '/';
export const nocRouteKey = '/noc';
export const ovbRouteKey = '/ovb';
export const mlRouteKey = '/metriclens';
export const aeRouteKey = '/app-experience';
export const vmRouteKey = '/vm';

const getPresetUseCaseRoutesAndKeys = () => {
  const presetRoutes = {};
  const presetKeyEventMap = {};
  const presetKeys = [] as string[];
  validPresetKeys.forEach((presetKey) => {
    const persistenceKey = `/preset-${presetKey}`;
    presetRoutes[`${baseUrl}/dashboard/preset/${presetKey}`] = persistenceKey;
    presetKeyEventMap[persistenceKey] = UPDATE_PERSISTED_COMMON_STATE_FOR_PRESET;
    presetKeys.push(persistenceKey);
  });
  return { presetRoutes, presetKeyEventMap, presetKeys };
};

export const routesWithPersistence = {
  '/': trendsRouteKey,
  [`${baseUrl}/dashboard/trends`]: trendsRouteKey,
  [`${baseUrl}/dashboard/real-time`]: nocRouteKey,
  [`${baseUrl}/dashboard/overview`]: ovbRouteKey,
  [`${baseUrl}/dashboard/metriclens`]: mlRouteKey,
  [`${baseUrl}/dashboard/app-experience`]: aeRouteKey,
  [`${baseUrl}/dashboard/viewer-module`]: vmRouteKey,
  ...getPresetUseCaseRoutesAndKeys().presetRoutes,
};

export const keyToEventMap = {
  [trendsRouteKey]: UPDATE_PERSISTED_COMMON_STATE,
  [nocRouteKey]: UPDATE_PERSISTED_NOC_STATE,
  [ovbRouteKey]: UPDATE_PERSISTED_OVERVIEW_STATE,
  [mlRouteKey]: UPDATE_PERSISTED_ML_STATE,
  [aeRouteKey]: UPDATE_PERSISTED_COMMON_STATE,
  [vmRouteKey]: UPDATE_PERSISTED_VM_STATE,
  ...getPresetUseCaseRoutesAndKeys().presetKeyEventMap,
};

export const persistenceKeys = [
  trendsRouteKey,
  nocRouteKey,
  ovbRouteKey,
  mlRouteKey,
  aeRouteKey,
  vmRouteKey,
  ...getPresetUseCaseRoutesAndKeys().presetKeys,
];

/**
 * For implementing this persistence feature, we will ensure which page to store the configuration.
 * This function can return the hash value of current url, except some special situations
 * @returns {*|string}
 */
export const getPersistentHashKey = () => {
  const currentUrl = window.location.pathname;
  // Check here if currentUrl has more param remove it
  const transformUrl = urlTransform(currentUrl);
  return routesWithPersistence[transformUrl] || transformUrl;
};

// adds a skip persistence flag to the action
// the persistence update config will ignore the corresponding action
const skipPersistence = (action) => ({ ...action, skipPersistence: true });
export function* setPersistedData(action) {
  yield put(skipPersistence(action));
}
